import { mapGetters, mapActions } from 'vuex'
import { LandingPage } from '@/components'

const components = {
  LandingPage
}

const computed = {
  ...mapGetters({
    aggregateModels: 'aggregateModels/list',
  }),
  currentDate () {
    return this.$store.getters['aggregateModels/currentDate'](this.config.key)
  },
  landingModels () {
    return this.$store.getters[`landingModels/${this.config.key}List`]
  },
  models () {
    return [...this.aggregateModels.filter(model => model.chamber === this.config.param)].sort((a, b) => new Date(a.date) - new Date(b.date))
  },
  model () {
    return this.models.find(model => model.date === this.currentDate)
  }
}

const methods = {
  ...mapActions({
    putSenateList: "landingModels/putSenateList",
    putHouseList: "landingModels/putHouseList",
  })
}

export default {
  components,
  computed,
  methods,
  data: () => ({
    loading: false
  }),
  beforeMount () {
    this.loading = true

    const isHousePage = this.config.param === "HOUSE";
    const promises = isHousePage
      ? [this.putHouseList()]
      : [this.putSenateList()];

    Promise.all(promises).then(() => {
      this.loading = false
    })
  }
}